import { jsx as _jsx } from "react/jsx-runtime";
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { is_dashboard_sorting_mode, select_ui_settings, set_ui_settings, } from 'console/redux/settings-actions';
import { memo, useCallback, useContext, useEffect, useMemo, useState, } from 'react';
import { DashboardControlProvider } from './control';
import { DashboardContent } from './types';
import { getDashboardUISettings } from './utils';
import { useBooleanState } from 'shared/hooks/state/boolean';
export const DashboardContentProvider = memo(function DashboardProvider(props) {
    const { children } = props;
    const { dashboard_settings } = useAppSelector(select_ui_settings);
    const setUISettings = useAction(set_ui_settings);
    const [devices_rfs, setDevicesRfs] = useState({});
    const [is_dashboard_ui_settings_changed, setIsDashboardUISettingsCancel, setIsDashboardUISettingsChanged,] = useBooleanState(false);
    const sorting_mode = useAppSelector(is_dashboard_sorting_mode);
    const { devices_ids, initial_dashboard_ui_settings } = useMemo(() => {
        if (dashboard_settings) {
            const { devices = [], ui_settings: initial_dashboard_ui_settings = {} } = dashboard_settings;
            const devices_ids = devices.map(({ id }) => id);
            return {
                devices_ids,
                initial_dashboard_ui_settings,
            };
        }
        return { devices_ids: [], initial_dashboard_ui_settings: {} };
    }, [dashboard_settings]);
    const augmented_dashboard_ui_settings = useMemo(() => getDashboardUISettings(initial_dashboard_ui_settings, devices_ids), [initial_dashboard_ui_settings, devices_ids]);
    const [dashboard_ui_settings, setDashboardUISettings] = useState(augmented_dashboard_ui_settings);
    useEffect(() => {
        setDashboardUISettings(augmented_dashboard_ui_settings);
    }, [augmented_dashboard_ui_settings]);
    const onSaveDashboardSettings = useCallback(() => {
        setUISettings({
            dashboard_settings: {
                ...dashboard_settings,
                ui_settings: dashboard_ui_settings,
            },
        });
        setIsDashboardUISettingsCancel();
        setUISettings({ sorting_mode: false });
    }, [dashboard_ui_settings, dashboard_settings]);
    const content = useMemo(() => ({
        devices_rfs,
        devices_ids,
        dashboard_ui_settings,
        sorting_mode,
        setDevicesRfs,
        onSaveDashboardSettings,
        is_dashboard_ui_settings_changed,
    }), [
        devices_rfs,
        setDevicesRfs,
        dashboard_ui_settings,
        is_dashboard_ui_settings_changed,
        sorting_mode,
        devices_ids,
        onSaveDashboardSettings,
    ]);
    return (_jsx(DashboardContent.Provider, { value: content, children: _jsx(DashboardControlProvider, { setDashboardUISettings: setDashboardUISettings, sorting_mode: sorting_mode, setIsDashboardUISettingsCancel: setIsDashboardUISettingsCancel, setIsDashboardUISettingsChanged: setIsDashboardUISettingsChanged, initial_dashboard_ui_settings: augmented_dashboard_ui_settings, children: children }) }));
});
export const useDashboard = () => useContext(DashboardContent);
